import { Languages } from 'helpers/enum'
import { getLanguageFromPath } from 'helpers/i18n'

type TitleObject = {
    [key: string]: string
}

const language = getLanguageFromPath()

// TODO: prepare unique titles for each app state (?)
const titles: Record<Languages, TitleObject> = {
    pl: {
        creator: 'Kreator biletów | Park of Poland - Suntago Wodny Świat',
        'creator-accommodation':
            'Kreator biletów | Park of Poland - Suntago Wodny Świat',
        selfcare: 'Kreator biletów | Park of Poland - Suntago Wodny Świat',
        error: 'Park of Poland - Suntago Wodny Świat',
        global: 'Park of Poland - Suntago Wodny Świat',
        'unlimited-card':
            'Kreator biletów | Park of Poland - Suntago Wodny Świat',
        'unlimited-renew': 'Odnów kartę Unlimited | Park of Poland',
        vouchers: 'Kreator voucherów | Park of Poland - Suntago Wodny Świat',
        null: 'Park of Poland - Suntago Wodny Świat',
    },
    en: {
        creator: 'Ticket creator | Park of Poland - Suntago Water World',
        'creator-accommodation':
            'Ticket creator | Park of Poland - Suntago Water World',
        selfcare: 'Ticket creator | Park of Poland - Suntago Water World',
        error: 'Park of Poland - Suntago Water World',
        global: 'Park of Poland - Suntago Water World',
        'unlimited-card':
            'Ticket creator | Park of Poland - Suntago Water World',
        'unlimited-renew': 'Renew Unlimited card | Park of Poland',
        vouchers: 'Vouchers creator | Park of Poland - Suntago Water World',
        null: 'Park of Poland - Suntago Water World',
    },
    uk: {
        creator: 'Майстер квитків | Park of Poland - Suntago Водний Світ',
        'creator-accommodation':
            'Майстер квитків | Park of Poland - Suntago Водний Світ',
        selfcare: 'Керувати замовленням | Park of Poland - Suntago Водний Світ',
        error: 'Park of Poland - Suntago Водний Світ',
        global: 'Park of Poland - Suntago Водний Світ',
        'unlimited-card':
            'Майстер карток Unlimited | Park of Poland - Suntago Водний Світ',
        'unlimited-renew': 'Поновити картку Unlimited | Park of Poland',
        vouchers: 'Майстер ваучерів | Park of Poland - Suntago Водний Світ',
        null: 'Park of Poland - Suntago Водний Світ',
    },
}

export const TITLES = titles[language]
